export const PAYMENT_PROVIDERS_TYPE_TO_SLUG = {
  paykeeper: 'paykeeper',
  yandex_kassa: 'ukassa',
  sber_acquiring: 'sberbank',
  alpha: 'alpha',
  liqpay: 'liqpay',
};
